import React, { useState } from "react";
import ReceptionistLayout from "../../Layouts/Receptionist/ReceptionistLayout";

export default function ReceptionistInsurance() {
    const [formData, setFormData] = useState({
        patientId: "",
        provider: "",
    });

    const insuranceClaims = [
        {
            claimId: "#C201",
            patient: "Ravi Kumar",
            status: "Processing",
        },
        {
            claimId: "#C202",
            patient: "Meena",
            status: "Approved",
        },
    ];

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        console.log(formData);
    };

    const getStatusBadge = (status) => {
        switch (status?.toLowerCase()) {
            case "approved":
                return "badge badge-light-success text-success fw-bold px-3 py-2 rounded-pill";
            case "processing":
                return "badge badge-light-warning text-warning fw-bold px-3 py-2 rounded-pill";
            case "rejected":
                return "badge badge-light-danger text-danger fw-bold px-3 py-2 rounded-pill";
            default:
                return "badge badge-light-secondary text-secondary fw-bold px-3 py-2 rounded-pill";
        }
    };

    return (
        <ReceptionistLayout>
            <div className="row g-4">
                <div className="col-12">
                    <div className="card border rounded-4 shadow-sm">
                        <div className="card-body p-4 p-lg-5">
                            <h3 className="fw-bold text-dark mb-5">Verify Insurance</h3>

                            <form onSubmit={handleSubmit}>
                                <div className="row g-4">
                                    <div className="col-12">
                                        <label className="form-label fw-semibold mb-1">
                                            Patient ID
                                        </label>
                                        <input
                                            type="text"
                                            name="patientId"
                                            className="form-control"
                                            value={formData.patientId}
                                            onChange={handleChange}
                                            placeholder="Enter patient ID"
                                        />
                                    </div>

                                    <div className="col-12">
                                        <label className="form-label fw-semibold mb-1">
                                            Insurance Provider
                                        </label>
                                        <select
                                            name="provider"
                                            className="form-select"
                                            value={formData.provider}
                                            onChange={handleChange}
                                        >
                                            <option value="">Select Provider</option>
                                            <option value="Star Health">Star Health</option>
                                            <option value="ICICI Lombard">ICICI Lombard</option>
                                            <option value="HDFC Ergo">HDFC Ergo</option>
                                        </select>
                                    </div>

                                    <div className="col-12">
                                        <button
                                            type="submit"
                                            className="btn btn-primary w-100 btn-sm fw-bold py-3 rounded-3"
                                        >
                                            Check Eligibility
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>

                <div className="col-12">
                    <div className="card border rounded-4 shadow-sm">
                        <div className="card-body p-4 p-lg-5">
                            <h3 className="fw-bold text-dark mb-5">Insurance Claims</h3>

                            <div className="table-responsive">
                                <table className="table align-middle table-row-dashed mb-0">
                                    <thead>
                                        <tr className="fw-bold text-dark border-bottom">
                                            <th>Claim ID</th>
                                            <th>Patient</th>
                                            <th>Status</th>
                                        </tr>
                                    </thead>

                                    <tbody className="fw-semibold text-gray-700">
                                        {insuranceClaims.map((item) => (
                                            <tr key={item.claimId}>
                                                <td>{item.claimId}</td>
                                                <td>{item.patient}</td>
                                                <td>
                                                    <span className={getStatusBadge(item.status)}>
                                                        {item.status}
                                                    </span>
                                                </td>
                                            </tr>
                                        ))}

                                        {insuranceClaims.length === 0 && (
                                            <tr>
                                                <td colSpan="3" className="text-center py-10 text-muted fw-semibold">
                                                    No insurance claims found
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </ReceptionistLayout>
    );
}
